import { getCurrentUAInfo } from '@just4/ua-info';
import { getWeixinVersion } from '@/assets/utils/browser';
import { compareVersions } from '@/assets/utils/utils';
import { escapeHTML, randomStr } from '@polyv/utils/src/string';

const uaInfo = getCurrentUAInfo();

export default {
  data() {
    return {
      // 是否处于微信小程序 webview 页面
      isWxMiniProgramWebview: false,
      isWeixin: uaInfo.client.isWx,
      // 是否高微信版本，高于 7.0.12
      isHighWeixinVersion: compareVersions(getWeixinVersion(), '7.0.12') >= 0,
    };
  },

  mounted() {
    this.checkWxMiniProgramWebview();
  },

  methods: {
    /**
     * 小程序 webview 下是否支持微信 SDK 功能跳转小程序页面
     */
    async supportWxMiniProgramNavigateTo() {
      if (!this.isWeixin || typeof this.getWeixinSdk !== 'function') {
        return false;
      }
      const wx = await this.getWeixinSdk();

      if (wx?.miniProgram?.getEnv) {
        return new Promise((resolve) => {
          wx.miniProgram.getEnv((res) => {
            resolve(res.miniprogram === true);
          });
        });
      } else {
        return false;
      }
    },

    /**
     * 检查当前环境是否为微信小程序 webview 环境中
     */
    async checkWxMiniProgramWebview() {
      const check = await this.supportWxMiniProgramNavigateTo();
      this.isWxMiniProgramWebview = check;
    },

    /**
     * 调用微信 sdk 方法跳转到当前小程序的某个页面
     */
    async toWxMiniProgram(url, preCallback) {
      if (!this.isWeixin || typeof this.getWeixinSdk !== 'function') {
        return false;
      }
      preCallback && preCallback();
      const wx = await this.getWeixinSdk();
      wx?.miniProgram?.navigateTo({
        url,
      });
      return true;
    },

    /**
     * 创建微信小程序打开按钮
     * @param options.wrap 外层节点
     * @param options.wxMiniprogramOriginalId
     * @param options.wxMiniprogramLink
     * @param options.classKey
     * @param options.width
     * @param options.height
     */
    createWxMiniProgramButton(options) {
      const { wrap, wxMiniprogramOriginalId, wxMiniprogramLink, classKey, width, height, lanuchCallback } = options;

      const id = 'wx-open-launch-weapp-' + randomStr(8);

      const htmlText = `
        <wx-open-launch-weapp
          id="${id}"
          username="${escapeHTML(wxMiniprogramOriginalId)}"
          path="${wxMiniprogramLink}"
        >
          <script type="text/wxtag-template">
            <style>.plv-iar-${classKey}-wx-buy-btn {width: ${width}px;height: ${height}px;}</style>
            <div class="plv-iar-${classKey}-wx-buy-btn"></div>
          </script>
        </wx-open-launch-weapp>
      `;

      wrap.innerHTML = htmlText;

      setTimeout(() => {
        const btn = document.querySelector(`#${id}`);
        btn.addEventListener('launch', () => {
          console.info('Launch success');
          lanuchCallback && lanuchCallback();
        });
        btn.addEventListener('error', (e) => {
          console.error('Launch error', e.detail);
        });
      }, 10);
    },
  },
};
